/**
 * Theme registry — H5 source-of-truth `styles.css:30,76,89,121` plus the
 * `[data-theme]` attribute toggle in `main.js:62-65`.
 *
 * The `accent` field mirrors each theme's `--accent` CSS variable. We
 * keep it as a JS constant alongside the CSS to deliberately avoid
 * RULE 17 AP12 (reverse-looking up CSS variables at runtime via
 * `getComputedStyle`). Rule of thumb: any value the JS layer needs to
 * read must be available without parsing live styles.
 *
 * If you change `--accent` in `styles.css`, also update the literal here
 * — the dual source is intentional.
 */
export const themeDefinitions = {
  default: {
    id: "default",
    label: "默认",
    dataTheme: null,
    accent: "#2f725d",
  },
  warm: {
    id: "warm",
    label: "暖纸",
    dataTheme: "warm",
    accent: "#b3692a",
  },
  spring: {
    id: "spring",
    label: "春日",
    dataTheme: "spring",
    accent: "#3a8a28",
  },
  night: {
    id: "night",
    label: "夜间",
    dataTheme: "night",
    accent: "#6dd1a8",
  },
} as const;

export type ThemeId = keyof typeof themeDefinitions;

export const THEME_OPTIONS = Object.values(themeDefinitions);

/**
 * Resolve a theme's `--accent` literal hex without reading the DOM. Used
 * by feature code that wants to seed a board / proposal / chip with the
 * currently active accent color without paying for a `getComputedStyle`
 * round-trip (RULE 17 AP12 avoidance).
 */
export function getThemeAccent(theme: ThemeId | string | null | undefined): string {
  const id = (theme ?? "default") as ThemeId;
  return themeDefinitions[id]?.accent ?? themeDefinitions.default.accent;
}
